import { router, useLocalSearchParams } from 'expo-router';
import { isWeb } from 'smoothie';

import LoginEmail from '../../../auth/components/email/LoginEmail';
import PlaidOAuthTest from '../../../auth/components/PlaidOAuthTest';
import { IS_PRODUCTION } from '../../../config/FruitfulEnvironment';
import { useViewEvents } from '../../../events/hooks/useViewEvents';
import { captureException } from '../../../logger/Logger';
import NoAccessScreen from '../../no-access';

export default function OAuthIndexPage() {
    const { trackViewOnce } = useViewEvents();
    trackViewOnce('OAuthIndexPage');

    const { auth_request_id } = useLocalSearchParams();

    if (auth_request_id == null) {
        if (IS_PRODUCTION) {
            return <NoAccessScreen />;
        } else {
            return <PlaidOAuthTest />;
        }
    }

    if (!isWeb) {
        captureException(
            new Error('Cannot access FDX OAuth index screen in native app'),
        );
        return <NoAccessScreen />;
    }

    const onSuccess = () => {
        router.navigate({
            pathname: '/auth/fdx/otp',
            params: {
                auth_request_id: auth_request_id as string,
            },
        });
    };

    return (
        <LoginEmail
            onSuccess={onSuccess}
            headerMessage="Log in to enable linking your accounts"
            includeSignupLink={false}
        />
    );
}
